function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fdde2e;}.cls-2{fill:#fce87b;}.cls-3{fill:#f1ecf0;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Crown"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3.48,21.94h25a1.48,1.48,0,0,1,0,3h-25a1.48,1.48,0,1,1,0-3"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M5.5,10.77,8.2,7.35a.68.68,0,0,1,1.05,0c.42.54,1,1.31,1.57,2a3.78,3.78,0,0,0,3,1.44h4.42a3.8,3.8,0,0,0,3-1.44l1.57-2a.67.67,0,0,1,1,0l2.71,3.42L22,18.7l-11.47.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M2.19,9.07a.67.67,0,0,1,1.14-.54l4.55,4.69a1.55,1.55,0,0,0,2.24,0l5.4-5.57a.68.68,0,0,1,1,0l5.4,5.57a1.55,1.55,0,0,0,2.24,0l4.55-4.69a.67.67,0,0,1,.76-.14.68.68,0,0,1,.38.68L28.52,21.94h-25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M16.5,17.27a.67.67,0,0,1-.5.21.71.71,0,0,1-.51-.21l-2.05-2a.71.71,0,0,1,0-1l2.05-2.05A.71.71,0,0,1,16,12a.67.67,0,0,1,.5.21l2.06,2.05a.71.71,0,0,1,0,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M6.61,19.19A.75.75,0,1,0,6,20a.75.75,0,0,0,.64-.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M6.22,16.44a.75.75,0,1,0-.64.85.75.75,0,0,0,.64-.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M5.83,13.68A.76.76,0,0,0,5,13a.75.75,0,0,0-.63.85h0a.73.73,0,0,0,.84.64.75.75,0,0,0,.64-.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M25.39,19.19A.75.75,0,1,1,26,20a.75.75,0,0,1-.64-.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M25.78,16.44a.75.75,0,1,1,.64.85.75.75,0,0,1-.64-.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.17,13.68a.75.75,0,1,1,1.48.21h0a.75.75,0,1,1-1.48-.21Z"
}));

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.eaa96271.svg";
export { ForwardRef as ReactComponent };